<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜索条件 -->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="线索来源">
                                <el-input v-model="q.clueResourceName" placeholder="请输入线索来源" :clearable="true"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createClue">
                                新增
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData"
                        :border="true"
                        max-height="560"
                        style="width: 100%"
                >
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            label="序号"
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="clueResourceType"
                            label="线索来源编码"
                            width="120" >
                    </el-table-column>
                    <el-table-column
                            prop="clueResourceName"
                            :show-overflow-tooltip="true"
                            label="线索来源"
                            width="150" >
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="状态"
                            width="120" >
                        <template scope="scope">
                            <span v-if="scope.row.status == 0">停用</span>
                            <span v-if="scope.row.status == 1">启用</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="luname"
                            label="修改人"
                            width="150" >
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="修改时间"
                            width="150" >
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            fixed="right"
                            width="340"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    v-if="scope.row.status == 1"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateClue('停用',scope.row)"
                            >停用</el-button>
                            <el-button
                                    v-if="scope.row.status == 0"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateClue('启用',scope.row)"
                            >启用</el-button>
                            <el-button
                                    v-if="scope.row.status == 1"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="downloadBarCode(scope.row)"
                            >二维码下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="insertCluesFlag" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>线索来源新增</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;" class="dialogout X-dai">
                        <el-form :model="add" label-position="right" :inline="true" :rules="editFormRules" label-width="120"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <el-form-item  label="线索来源" prop="clueResourceName">
                                <el-input v-model="add.clueResourceName" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>

                    </div>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialog">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="addClues()">提交</el-button>
                    </div>
                </div>
            </el-dialog>
            <div class="h-pagination2">
                <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from "../../../api/SystemService";
    import updownfile from '../../../utils/updownfile'
    export default {
        comments: {

        },
        data(){
            return {
                tableData:[],
                q:{
                    clueResourceName:'',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                add:{
                    clueResourceName:'',
                },
                insertCluesFlag:false,
                editFormRules: {
                    clueResourceName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                },
                multipleSelection:[],
            }
        },
        methods: {
            //检索
            query(){
                ss.BscClueManage.selectCluesPage(this.q).then(rd =>{
                    this.tableData = rd.records;
                    this.q.total = rd.total;
                })
            },
            //重置
            resetData(){
                this.q.clueResourceName = '';
            },
            //新增线索来源弹窗
            createClue(){
                this.add.clueResourceName = '';
                this.insertCluesFlag = true;
            },
            //取消新增
            closeDialog(){
                this.insertCluesFlag = false;
            },
            //线索来源停用启用状态修改
            updateClue(v,row){
                var data = {
                    id:null,
                    statusFlag:null,
                }
                data.id = row.id;
                data.statusFlag = row.statusFlag;
                ss.BscClueManage.updateStatus(data).then(rd =>{
                    if(rd.f){
                        this.query();
                    }
                })
            },
            addClues(){
                ss.BscClueManage.insertCluesResource(this.add).then(rd =>{
                    if(rd.f){
                        this.closeDialog();
                        this.query();
                    }
                })
            },
            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            downloadBarCode(v){

                ss.BscClueManage.createClueBarcode(v).then(res =>{

                    updownfile.png(res,v.clueResourceName+'.png')

                })

            },
        },
        created() {
            this.query();
        },
    }
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:110px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    /*/deep/ .h-elformWrap-1 .el-form-item__content{*/
    /*    width: 78%;*/
    /*}*/
    /deep/ .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }

    .addPro {
        width: 100%;
        /* display:flex; */
    }

    .addPro .el-form-item {
        width: 45% !important;
    }

    .addPro .el-form-item /deep/ .el-form-item__content {
        width: 115px;
    }
    /*设置父级样式*/
    .vue-treeselect >>> .vue-treeselect__control {
        width: 150px;
    }
    .el-switch{
        margin: auto auto auto 20px;
    }
    /*.projectCon p{*/
    /*  justify-content: space-between;*/
    /*  align-items:center;*/
    /*  font-size: 14px;*/
    /*  border-bottom:#1b78e6 1px dashed;*/
    /*  padding: 5px 0;*/
    /*  margin: 0 auto 10px auto;*/
    /*  color: #1b78e6;*/
    /*}*/
</style>